import React from 'react';
import HeroSection from '../components/HeroSection';
import MissionSection from '../components/MissionSection';
import ServicesSection from '../components/ServicesSection';
import ProcessSection from '../components/ProcessSection';
import WhyUsSection from '../components/WhyUsSection';
import TrustSection from '../components/TrustSection';

const HomePage = () => {
  return (
    <main>
      <HeroSection />
      <MissionSection />
      <ServicesSection />
      <ProcessSection />
      <WhyUsSection />
      <TrustSection />
    </main>
  );
};

export default HomePage;